import { media } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

import Container from './Container';
import EmailShare from './EmailShare';
import FacebookShare from './FacebookShare';
import GoogleShare from './GoogleShare';
import LinkedinShare from './LinkedinShare';
import TwitterShare from './TwitterShare';
import { ShareProps } from './types';

const wrapperOnMobile = media.phone`
  flex-wrap: nowrap;
  img {
    max-width: 40px;
  }
  ${Container} {
    margin: 0 16px 0 0;
    h5 {
      font-size: 12px;
      margin: 10px -11px 0;
    }
    &:first-child {
      margin-left: 10px ;
    }
    &:last-child {
      margin-right: 10px ;
    }
  }
`;

const ShareInServicesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 24px 0 0 0;
  justify-content: space-between;
  ${wrapperOnMobile};
`;

const ShareInServices: FC<ShareProps> = props => (
  <ShareInServicesWrapper>
    <FacebookShare {...props} />
    <TwitterShare {...props} />
    <LinkedinShare {...props} />
    <GoogleShare {...props} />
    <EmailShare {...props} />
  </ShareInServicesWrapper>
);

export default ShareInServices;
